import { identifyFee } from '@vp/om-tax-display';
import cartActionTypes from '../cart/actionTypes';
import createReducer from '../utils/createReducer';
import type { ShippingOption, ShippingOptionsState } from '../../types';

const initialState: ShippingOptionsState = {
  shippingOptions: undefined,
  selectedShippingMethodId: undefined,
  selectedShippingMethodIsUnverified: false,
  selectedShippingMethodIsDefaulted: false,
  selectedShippingMethodName: undefined,
  selectedShippingMethodEarliestArrivalDate: undefined,
  selectedShippingMethodLocalizedDisplayInfo: undefined,
  deliveryOptionMetadata: undefined,
  isOptionsOperationInFlight: false,
  caveats: undefined,
  retrievalStatus: undefined,
};

export default createReducer(initialState)({
  [cartActionTypes.CART_LOAD_SUCCESS]: (
    state: ShippingOptionsState,
    action: any
  ) => {
    const {
      shippingData: {
        shippingQuotesData,
        shippingMethodId,
        shippingMethodName,
        earliestArrivalDate,
        localizedDisplayInfo,
        deliveryOptionMetadata,
      },
    } = action.cart;
    const { shippingQuotes, status, ...rest } = shippingQuotesData || {};
    return {
      ...state,
      ...rest,
      isLoaded: true,
      isOptionsArrayOutdated: false,
      error: undefined,
      selectedShippingMethodId: shippingMethodId,
      selectedShippingMethodName: shippingMethodName,
      selectedShippingMethodEarliestArrivalDate: earliestArrivalDate,
      selectedShippingMethodLocalizedDisplayInfo: localizedDisplayInfo,
      deliveryOptionMetadata,
      shippingOptions: shippingQuotes?.map((sq: ShippingOption) => ({
        ...sq,
        pricingData: sq.pricingData
          ? {
              ...sq.pricingData,
              components: sq.pricingData.components?.map((component: any) => ({
                ...component,
                // tag the shipping components with their fee identifier OR 'shipping' if not a fee
                identifiers: [identifyFee(component) ?? 'shipping'],
              })),
            }
          : undefined,
      })),
      retrievalStatus: status,
    };
  },
});
